/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
import SidePopup from '@jobseeker/lotus/components/SidePopUp';
import {Box} from '@jobseeker/lotus/foundations';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {useState} from 'react';
import {Link, RadioGroup, Typography} from '@mui/material';
import {ButtonV2, Select, Radio} from '@jobseeker/lotus/elements';
import {useFormik} from 'formik';
import * as yup from 'yup';
import {SurveyCheckGreen} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
const YES = 1;
const NO = 2;
const REQUIRED_MSG = '(This is required)';
const validationSchema = yup.object({
  maritalStatus: yup.number().required(REQUIRED_MSG).moreThan(0, REQUIRED_MSG),
  workingMother: yup.number().required(REQUIRED_MSG).moreThan(0, REQUIRED_MSG),
  singleParent: yup.number().required(REQUIRED_MSG).moreThan(0, REQUIRED_MSG),
  careerBreak: yup.number().required(REQUIRED_MSG).moreThan(0, REQUIRED_MSG),
  // differentlyAbled: yup
  //   .number()
  //   .required(REQUIRED_MSG)
  //   .moreThan(0, REQUIRED_MSG),
});

export default (props: any) => {
  const [menuOpen, setMenuOpen] = useState('');

  const formik = useFormik({
    initialValues: {
      maritalStatus: 0,
      workingMother: 0,
      singleParent: 0,
      careerBreak: 0,
      // differentlyAbled: 0,
    },
    validationSchema: validationSchema,
    onSubmit: values => {
      // console.log(JSON.stringify(values, null, 2));
      if (props.onSubmit) {
        props.onSubmit(values);
      }
    },
    validateOnChange: false,
    validateOnBlur: false,
  });

  const maritialStatus = [
    {label: 'Single/Unmarried', value: 1},
    {label: 'Married', value: 2},
    {label: 'Widowed', value: 3},
    {label: 'Divorced', value: 4},
    {label: 'Separated', value: 5},
    {label: 'Others', value: 6},
  ];

  return (
    <SidePopup
      variant={VersionVariants.VERSION_ONE}
      onClose={props.onClose}
      imgUrl={props.imgUrl}
      show={props.show}
      sx={{width: 390, height: 'fit-content'}}
    >
      {props.isSuccess ? (
        <Box maxHeight={'calc(80vh - 60px)'} overflow={'scroll'}>
          <Box
            sx={{
              background: '#91B87929',
              p: 4,
              textAlign: 'center',
              // height: '206px',
            }}
            // display={'flex'}
            // justifyContent={'center'}
          >
            <Image
              src={SurveyCheckGreen}
              width={77}
              height={77}
              alt="successIcon"
            />
            <Typography mt={3} variant="subtitle2">
              Your changes have been saved successfully
            </Typography>
            <Typography pb={'2px'} fontSize={10} fontWeight={500}>
              You can change your preferences any time in your profile
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box maxHeight={'calc(80vh - 60px)'} overflow={'scroll'}>
          <Box sx={{background: '#91B87929', p: 2}}>
            <Typography
              fontFamily={'Abhaya Libre'}
              fontWeight={700}
              fontSize={18}
            >
              Tell us More
            </Typography>
            <Typography variant="body3">
              We have started an initiative{' '}
              <Typography
                variant="subtitle3"
                fontWeight={500}
                color={'primary'}
              >
                Maven
              </Typography>{' '}
              where we promote the role of women in workforce. Our focus is to
              enable women to take up leadership roles in organizations driven
              by equal opportunities.
              <br />
              Fill in the below data to help us show you more of such
              opportunities. You can update this information anytime by visiting
              your profile. To learn more on how we use this data, please check
              our{' '}
              <Link
                sx={{textDecoration: 'none', fontWeight: 500}}
                href="https://www.iimjobs.com/privacy"
                target="__blank"
              >
                privacy policy
              </Link>
              .
            </Typography>
          </Box>
          <Box
            px={2}
            component={'form'}
            onSubmit={(e: any) => formik.handleSubmit(e)}
          >
            <Box my={3} lineHeight={0} mt={2}>
              <Typography variant="subtitle1">Marital Status</Typography>

              <Box mt={1}>
                <Select
                  menuOpen={menuOpen === 'maritalStatus'}
                  setMenuOpen={setMenuOpen}
                  variant={VersionVariants.VERSION_TWO}
                  options={maritialStatus}
                  label={'Select your Marital Status'}
                  // value={props?.formValue?.sort}
                  name="maritalStatus"
                  value={[formik.values?.maritalStatus]}
                  onChange={formik.handleChange}
                  MenuProps={{
                    disablePortal: true,
                  }}
                  // onBlur={formik.handleBlur}
                  error={
                    !!formik.touched?.maritalStatus &&
                    Boolean(formik.errors?.maritalStatus)
                  }
                  helperText={
                    formik.touched?.maritalStatus &&
                    formik.errors?.maritalStatus
                  }
                />
              </Box>
              {formik.errors?.maritalStatus && (
                <Typography variant="caption" mt={0.6} color={'error'}>
                  {formik.errors?.maritalStatus}
                </Typography>
              )}
            </Box>
            <Box my={3} lineHeight={0}>
              <Typography variant="subtitle1">
                Are you a working mother?{' '}
              </Typography>
              <RadioGroup
                onBlur={formik.handleBlur}
                sx={{ml: 0.25, mt: 1.5, display: 'flex', flexDirection: 'row'}}
                value={formik.values?.workingMother}
                name="workingMother"
                onChange={formik.handleChange}
              >
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="workingMother"
                  value={YES}
                  label={<Typography variant="subtitle2">Yes</Typography>}
                />
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="workingMother"
                  value={NO}
                  label={<Typography variant="subtitle2">No</Typography>}
                />
              </RadioGroup>
              {formik.errors?.workingMother && (
                <Typography variant="caption" mt={0.4} color={'error'}>
                  {formik.errors?.workingMother}
                </Typography>
              )}
            </Box>
            <Box my={3} lineHeight={0}>
              <Typography variant="subtitle1">
                Are you a single parent?{' '}
              </Typography>

              <RadioGroup
                sx={{ml: 0.25, mt: 1.5, display: 'flex', flexDirection: 'row'}}
                value={formik.values?.singleParent}
                name="singleParent"
                onChange={formik.handleChange}
              >
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="singleParent"
                  value={YES}
                  label={<Typography variant="subtitle2">Yes</Typography>}
                />
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="singleParent"
                  value={NO}
                  label={<Typography variant="subtitle2">No</Typography>}
                />
              </RadioGroup>
              {formik.errors?.singleParent && (
                <Typography variant="caption" mt={0.4} color={'error'}>
                  {formik.errors?.singleParent}
                </Typography>
              )}
            </Box>
            <Box my={3} lineHeight={0}>
              <Typography variant="subtitle1">
                Are you returning after a career break?
              </Typography>

              <RadioGroup
                sx={{ml: 0.25, mt: 1.5, display: 'flex', flexDirection: 'row'}}
                value={formik.values?.careerBreak}
                name="careerBreak"
                onChange={formik.handleChange}
              >
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="careerBreak"
                  value={YES}
                  label={<Typography variant="subtitle2">Yes</Typography>}
                />
                <Radio
                  sx={{py: 0}}
                  size={16}
                  name="careerBreak"
                  value={NO}
                  label={<Typography variant="subtitle2">No</Typography>}
                />
              </RadioGroup>
              {formik.errors?.careerBreak && (
                <Typography variant="caption" mt={0.4} color={'error'}>
                  {formik.errors?.careerBreak}
                </Typography>
              )}
            </Box>
            <Box my={3} lineHeight={0}>
              <ButtonV2
                // disabled={!(formik.isValid && formik.dirty)}
                type="submit"
                variant="contained"
                color="secondary"
              >
                Submit
              </ButtonV2>
              <ButtonV2 onClick={props.onClose}>Cancel</ButtonV2>
            </Box>
          </Box>
        </Box>
      )}
    </SidePopup>
  );
};
